import { createSlice } from "@reduxjs/toolkit";
import { signInUser } from "../Components/Utility/Auth";
import {
  startOfToday,
  endOfToday,
  format,
  formatDistance,
  isWithinInterval,
  parseISO,
} from "date-fns";

const user = signInUser();
const { aamarId = "", warehouse = "", storeSettings = {} } = user || {};
// const {id, warehouse} = user;
// console.log("user from  posSlice:", user);

/**
 * TOTAL CALCULATIONS
 */
const totalCalculation = (state) => {
  const cash = parseInt(state?.paidAmount?.cash) || 0;
  const usePointAmount = parseInt(state?.paidAmount?.point) || 0;
  const mfs = parseInt(state?.paidAmount?.mfs?.amount) || 0;
  const card = parseInt(state?.paidAmount?.card?.amount) || 0;
  const promo_discount = parseInt(state?.promo_discount) || 0;
  const discount = parseInt(state?.discount) || 0;
  const grossTotal = parseInt(state.grossTotal) || 0;

  const totalRecivedAmount = cash + card + mfs + usePointAmount;

  const changeAmount =
    totalRecivedAmount + promo_discount + discount - grossTotal;

  // console.log("TOTAL CALCULATIONS Tigger from slice",totalRecivedAmount,changeAmount)

  state.totalReceived = totalRecivedAmount;
  // state.grossTotal = grossTotal - discount
  state.changeAmount = changeAmount - discount;
};

const posFinalizer = (state) => {
  // console.log(cart, type);
  let totalItem = 0;
  let total = 0;
  let vatAmount = 0;
  let promoPrice = 0;
  let promoVat = 0;

  let returnTotalItem = 0;
  let returnTotal = 0;
  let returnVatAmount = 0;

  // Products
  state?.products?.length > 0 &&
    state?.products?.forEach((item) => {
      // TODO:: update qty system (totalItem) by unit
      totalItem = totalItem + parseInt(isLoose(item.article_code, item.qty));
      total = total + itemTotal(item.qty, item.mrp);
      const promo = item?.promo ? item.promo : {};
      promoPrice = promoPrice + itemPromo(item.qty, promo, item.mrp);
      // if(item?.promo){
      // vatAmount = vatAmount + itemVat(item.vat, item.qty, (item.mrp-promoPrice)); //vat = how much like 5% ||
      // }else{
      vatAmount = vatAmount + itemVat(item.vat, item.qty, item.mrp); //vat = how much like 5% ||
      promoVat = isVatable(item?.article_code) ? 0 : (promoPrice * 5) / 100;
    });

  // return PRODUCT
  state?.returnProducts?.length > 0 &&
    state?.returnProducts?.forEach((item) => {
      returnTotalItem =
        returnTotalItem + parseInt(isLoose(item.article_code, item.qty));
      returnTotal = returnTotal + itemTotal(item.qty, item.mrp);
      // returnVatAmount = returnVatAmount + itemVat(item.vat, item.qty, item.mrp); //vat = how much like 5% ||
    });

  if (promoVat > 0) {
    vatAmount = vatAmount - promoVat;
  }
  const grossTotal = total + vatAmount - returnTotal;
  const grossTotalRound = Math.round(grossTotal);
  const newPoint = Math.floor(Math.round(grossTotalRound) / 100);

  const prevGrossRound = state.grossTotalRound;

  state.totalItem = totalItem;
  state.total = total;
  state.vatAmount = vatAmount;
  state.grossTotal = grossTotal - state.discount;
  state.grossTotalRound = grossTotalRound - state.discount;
  state.newPoint = newPoint;
  state.promoPrice = promoPrice;

  state.returnCal.totalItem = returnTotalItem;
  state.returnCal.total = returnTotal;
  state.returnCal.grossTotal = returnTotal;
  state.returnCal.vat = returnVatAmount;
  state.returnCal.grossTotalRound = Math.floor(Math.round(returnTotal));
  state.returnCal.point = Math.floor(Math.round(returnTotal)) / 100;

  if (state.due && (state.paidAmount?.cash === undefined || state.paidAmount?.cash === null || state.paidAmount?.cash === 0 || state.paidAmount?.cash === prevGrossRound)) {
    state.paidAmount.cash = grossTotalRound - state.discount;
  }
};

const isLoose = (id, qty) => {
  var decimals = qty - Math.floor(qty);
  const looseCat = [59, 54, 61];
  const cat = parseInt(id?.toString()?.substring(0, 2));
  // console.log(cat, looseCat.includes(cat))
  if (looseCat.includes(cat) && decimals > 0) {
    return 1;
  } else {
    return qty;
  }
};

const isVatable = (id) => {
  const looseCat = [59, 54, 61];
  const cat = parseInt(id?.toString()?.substring(0, 2));
  // console.log(cat, looseCat.includes(cat))
  if (looseCat.includes(cat)) {
    return true;
  } else {
    return false;
  }
};

const itemPromo = (qty, promo, mrp) => {
  let promoPrice = 0;
  if (promo?.promo_type) {
    promoPrice =
      parseFloat(qty) *
      ((parseFloat(promo?.promo_price ? promo?.promo_price : 0) / 100) * mrp);
  } else {
    promoPrice =
      parseFloat(qty) * parseFloat(promo?.promo_price ? promo?.promo_price : 0);
  }

  return parseFloat(promoPrice);
};

const itemTotal = (qty, price) => {
  // console.log("promo list", promo)
  const itemTotal = parseFloat(qty) * parseFloat(price);
  return parseFloat(itemTotal);
};

const itemVat = (vat, qty, price) => {
  const itemVatTotal = itemTotal(qty, price) * (parseFloat(vat ||0) / 100);
  // console.log("itemVatTotal", itemVatTotal, vat, qty, price);

  return parseFloat(itemVatTotal);
};

// const itemVatTotal = (qty, price) => {
//   const itemTotal = parseFloat(qty) * parseFloat(price);
//   // const itemVat = parseFloat(qty) * parseFloat(price);
//   // const itemVatTotal = parseFloat(itemTotal + itemVat);

//   // console.log("itemTotal", itemTotal, qty, price);
//   return itemTotal;
// };

// const toDecimal = (float) => {
//   if (float) {
//     return float.toFixed(2);
//   }
//   return float;
// };

const intialState = {
  invoiceId: "0171000000",
  source: "POS",
  warehouse: user?.warehouse,
  aamarId: user?.aamarId,
  products: [],
  returnProducts: [],
  returnCal: {
    totalItem: 0,
    total: 0,
    vat: 0,
    grossTotal: 0,
    grossTotalRound: 0,
    point: 0,
  },
  returnInvoice: null,
  paidAmount: {
    cash: 0,
    mfs: {
      name: "bkash",
      amount: 0,
    },
    card: {
      name: "visa",
      amount: 0,
    },
    point: 0,
  },
  changeAmount: 0,
  totalReceived: 0,
  grossTotal: 0,
  grossTotalRound: 0,
  totalItem: 0,
  total: 0,
  vat: 0,
  point: {
    old: 0,
    new: 0,
  },
  todayPoint: 0,
  due: false,
  billType: "paid",
  discount: 0,
  billerId: user?.id || user?._id || user?.userId,
  group: null,
  customerId: "62e301c1ee6c8940f6ac1515",
  customerPhone: "0171000000",
  customerName: "Walkway Customer",
  updateUser: user?.id || user?._id || user?.userId,
  promo_discount: 0,
  photo: null,
  status: "complete",
};

export const posSlice = createSlice({
  name: "posSales",
  initialState: intialState,

  reducers: {
    addToCartReducer: (state, actions) => {
      // console.log("ADD TO CART", actions.payload);
      //data, price, qty
      let products = state.products;
      const data = actions.payload.data;
      const price = actions.payload.price;
      const qty = actions.payload.qty;
      let newProduct = {};
      console.log("pos Slice Data", data);
      const idExist = products.find((pro) => pro.id === data._id);
      const rest = products.filter((pro) => pro.id !== data._id);

      if (idExist) {
        // TODO:: INCREASE QUANTITY
        const nextQty = (parseFloat(idExist.qty) || 0) + 1;
        const cartProducts = [
          ...rest,
          {
            ...idExist,
            qty: nextQty,
            vatAmount: itemVat(idExist?.vat, nextQty, idExist?.mrp),
            total: itemTotal(nextQty, idExist?.mrp),
          },
        ];
        state.products = cartProducts;
        posFinalizer(state);
        totalCalculation(state);
      } else {
        let newPrice = {};
        // console.log('new price', newPrice)
        const priceList = data.priceList;
        const activePriceList = priceList.filter(
          (pr) => pr.status === "active" && pr._id === price
        );

        if (activePriceList.length > 0) {
          newPrice = {
            id: activePriceList[0]._id,
            mrp: activePriceList[0].mrp,
            tp: activePriceList[0].tp,
          };
        }

        console.log("New newPrice", newPrice);

        if (data?.promo_start && data?.promo_end) {
          const promoStart = parseISO(data.promo_start);
          const promoEnd = parseISO(data.promo_end);
          if (!isNaN(promoStart) && !isNaN(promoEnd)) {
            const isBetween = isWithinInterval(new Date(), {
              start: promoStart,
              end: promoEnd,
            });
            if (isBetween) {
              newPrice = {
                ...newPrice,
                promo_price: data?.promo_price,
                promo_type: data?.promo_type,
              };
            }
          }
        }

        // console.log("New vat", itemVat(data?.vat, qty, newPrice?.mrp),qty,data?.vat,newPrice?.mrp);
        const initialMrp = newPrice?.mrp
          ? newPrice?.mrp
          : data?.priceList && data?.priceList[0]?.mrp
          ? data.priceList[0].mrp
          : data?.mrp || 0;

        newProduct = {
          id: data?._id,
          priceId: newPrice.id,
          name: data.name,
          article_code: data.article_code,
          ean: data.ean,
          stock: data.stock,
          mrp: initialMrp,
          originalMrp: initialMrp,
          qty: qty,
          tp:
            newPrice?.tp !== undefined && newPrice?.tp !== null
              ? newPrice.tp
              : data?.priceList && data?.priceList[0]?.tp !== undefined
              ? data.priceList[0].tp
              : data?.tp !== undefined
              ? data.tp
              : 0,
          vat: data?.vat ? data?.vat : 0,
          vatAmount: itemVat(data?.vat, qty, initialMrp),
          total: itemTotal(qty, initialMrp),
          aamarId: aamarId,
          warehouse: warehouse,
          unit: data.unit,
          photo: data?.photo,
          // priceList: data?.priceList[0]?.mrp,
          promo: {
            promo_price: newPrice?.promo_price ? newPrice?.promo_price : 0,
            promo_type: newPrice?.promo_type ? newPrice.promo_type : false,
          },
          supplier:
            activePriceList && activePriceList.length > 0
              ? activePriceList[0]?.supplier
              : 0,
          order: products.length + 1,
        };
        products = [...products, newProduct];
        state.products = products;
        posFinalizer(state);
        totalCalculation(state);
      }
    },
    removeFromDbReducer: (state, actions) => {
      const id = actions.payload.id;
      state.products = (state.products || []).filter((p) => p.article_code !== id && p.id !== id);
      posFinalizer(state);
      totalCalculation(state);
    },
    deleteShoppingCartReducer: (state) => {
      state.products = [];
      state.returnProducts = [];
      posFinalizer(state);
      totalCalculation(state);
    },
    removeQuantityReducer: (state, actions) => {
      const products = state.products;
      const article_code = actions.payload;

      const selectedItem = products.find(
        (p) => p.article_code === article_code
      );

      if (selectedItem) {
        selectedItem.qty =
          parseFloat(selectedItem.qty) > 0
            ? parseFloat(selectedItem.qty) - 1
            : 0;

        selectedItem.vatAmount = itemVat(
          selectedItem?.vat,
          parseFloat(selectedItem.qty) > 0 ? parseFloat(selectedItem.qty) : 0,
          selectedItem?.mrp
        );
        selectedItem.total = itemTotal(
          parseFloat(selectedItem.qty) > 0 ? parseFloat(selectedItem.qty) : 0,
          selectedItem?.mrp
        );
      }
      posFinalizer(state);
      totalCalculation(state);
    },
    addQuantityReducer: (state, actions) => {
      const products = state.products;
      const article_code = actions.payload;
      const selectedItem = products.find(
        (p) => p.article_code === article_code
      );

      if (selectedItem) {
        selectedItem.qty =
          parseFloat(selectedItem.qty) >= 0
            ? parseFloat(selectedItem.qty) + 1
            : 0;
        selectedItem.vatAmount = itemVat(
          selectedItem?.vat,
          parseFloat(selectedItem?.qty),
          selectedItem?.mrp
        );
        selectedItem.total = itemTotal(
          parseFloat(selectedItem?.qty),
          selectedItem?.mrp
        );
      }
      posFinalizer(state);
      totalCalculation(state);
    },
    removeItemFormCartReducer: (state, actions) => {
      const article_code = actions.payload;
      state.products = (state.products || []).filter((p) => p.article_code !== article_code);
      posFinalizer(state);
      totalCalculation(state);
    },
    removeItemFormReturnCartReducer: (state, actions) => {
      const article_code = actions.payload;
      state.returnProducts = (state.returnProducts || []).filter((p) => p.article_code !== article_code);
      posFinalizer(state);
      totalCalculation(state);
    },
    customQtyReducer: (state, actions) => {
      const products = state.products;
      const { article_code, qty } = actions.payload;

      const selectedItem = products.find(
        (p) => p.article_code === article_code
      );

      if (!selectedItem) {
        return state;
      }

      const numQty = parseFloat(qty) || 0;
      selectedItem.qty = numQty;
      selectedItem.vatAmount = itemVat(selectedItem?.vat, numQty, selectedItem?.mrp);
      selectedItem.total = itemTotal(numQty, selectedItem?.mrp);

      posFinalizer(state);
      totalCalculation(state);
    },
    customPriceReducer: (state, actions) => {
      const { id, article_code, e, mrp } = actions.payload || {};
      const products = state.products || [];

      const selectedItem = products.find(
        (p) =>
          (article_code && p.article_code === article_code) ||
          (id && (p.id === id || p._id === id || p.article_code === id))
      );

      if (!selectedItem) {
        return state;
      }

      let newMrp = selectedItem.mrp;
      let newTp = selectedItem.tp;
      let newPriceId = selectedItem.priceId;
      let newSupplier = selectedItem.supplier;
      let newOriginalMrp = selectedItem.originalMrp || selectedItem.mrp;

      if (e) {
        newMrp = parseFloat(e.mrp !== undefined ? e.mrp : selectedItem.mrp) || 0;
        if (e.tp !== undefined && e.tp !== null) newTp = parseFloat(e.tp) || 0;
        if (e.option !== undefined) newPriceId = e.option;
        if (e.supplier !== undefined) newSupplier = e.supplier;
        if (e.mrp) newOriginalMrp = parseFloat(e.mrp) || 0;
      } else if (mrp !== undefined) {
        newMrp = parseFloat(mrp) || 0;
      }

      // Buying price check (kina dam): cannot be lower than tp
      const minPrice =
        parseFloat(
          newTp !== undefined && newTp !== null ? newTp : selectedItem.tp || 0
        ) || 0;
      if (newMrp < minPrice) {
        newMrp = minPrice;
      }

      const updatedProducts = products.map((product) => {
        if (
          (article_code && product.article_code === article_code) ||
          (id &&
            (product.id === id ||
              product._id === id ||
              product.article_code === id))
        ) {
          const qty = parseFloat(product.qty) || 0;
          return {
            ...product,
            priceId: newPriceId,
            mrp: newMrp,
            originalMrp: newOriginalMrp,
            tp: newTp,
            supplier: newSupplier,
            vatAmount: itemVat(product?.vat, qty, newMrp),
            total: itemTotal(qty, newMrp),
          };
        }
        return product;
      });

      state.products = updatedProducts;
      posFinalizer(state);
      totalCalculation(state);
    },
    posFinalizerReducer: (state) => {
      posFinalizer(state);
      totalCalculation(state);
    },
    posCalculationReducer: (state) => {
      totalCalculation(state);
    },
    resetHoldReducer: (state, action) => {
      // Replace the entire state with action.payload
      // console.log("HOLD DATA", action.payload);
      return action.payload;
    },
    // All New Reducers are avobe this line ============================
    selectInvoiceId: (state, action) => {
      return {
        ...state,
        invoiceId: action.payload,
      };
    },
    selcetUpdateUser: (state, action) => {
      return { ...state, updateUser: action.payload };
    },
    selcetBiller: (state, action) => {
      return {
        ...state,
        billerId: action.payload,
      };
    },
    selectWarehouse: (state, action) => {
      return {
        ...state,
        warehouse: action.payload,
      };
    },
    selectAamarId: (state, action) => {
      return {
        ...state,
        aamarId: action.payload,
      };
    },
    selcetCustomer: (state, action) => {
      // console.log("Add Customer", action.payload);
      // const newPoint = state.point.new + action.payload.point;
      return {
        ...state,
        customerId: action.payload.customerId,
        point: {
          old: action.payload.point,
          new: state.todayPoint + action.payload.point,
        },
        customerPhone: action.payload.phone,
        customerName: action.payload.name,
        group: action.payload.group ? action.payload.group : null,
      };
    },
    selectGroup: (state, action) => {
      return {
        ...state,
        group: action.payload.group,
      };
    },
    selcetProductsCart: (state, action) => {
      return {
        ...state,
        products: action.payload,
      };
    },

    saleFinalize: (state, action) => {
      // console.log(state.discount);
      // console.log(
      //   state.point.old,
      //   action.payload.newPoint,
      //   state.paidAmount.point
      // );
      const pointToday = Math.floor(action?.payload?.grossTotalRound / 100);
      const newPoint =
        Number(state?.point?.old) + pointToday - state?.paidAmount?.point;

      // console.log("action.payload", action.payload);
      return {
        ...state,
        totalItem: action.payload.totalItem,
        total: action.payload.total,
        vat: action.payload.vatAmount - action.payload.reVat,
        grossTotal:
          action.payload.grossTotal -
          action.payload.promo_discount -
          action.payload.discount -
          action.payload.reGrossTotalRound,
        grossTotalRound: Math.round(
          action.payload.grossTotalRound -
            action.payload.promo_discount -
            action.payload.discount -
            action.payload.reGrossTotalRound
        ),
        // discount: action.payload.discount,
        promo_discount: action.payload.promo_discount,

        changeAmount:
          state.totalReceived +
          action.payload.reTotal -
          action.payload.grossTotalRound,
        point: {
          ...state.point,
          new: newPoint - action.payload.rePoint,
        },
        todayPoint: pointToday,
        returnCal: {
          ...state.returnCal,
          totalItem: parseFloat(action.payload.reTotalItem),
          total: action.payload.reTotal,
          grossTotalRound: action.payload.reGrossTotalRound,
          grossTotal: action.payload.reGrossTotal,
          point: action.payload.rePoint,
          vat: action.payload.reVat,
        },
      };
    },
    salesPromoPrice: (state, action) => {
      return {
        ...state,
        promo_discount: action.payload,
      };
    },
    salesAmountRecived: (state, action) => {
      return {
        ...state,
        totalReceived: action.payload.totalRecivedAmount,
        changeAmount: action.payload.changeAmount - state.promo_discount,
      };
    },

    saleCash: (state, action) => {
      state.paidAmount.cash = action.payload;
      totalCalculation(state);
    },
    saleCardName: (state, action) => {
      return {
        ...state,
        paidAmount: {
          ...state.paidAmount,
          card: { ...state.paidAmount.card, name: action.payload },
        },
      };
    },
    saleCardAmount: (state, action) => {
      state.paidAmount.card.amount = action.payload;
      totalCalculation(state);
    },
    saleMfsName: (state, action) => {
      return {
        ...state,
        paidAmount: {
          ...state.paidAmount,
          mfs: { ...state.paidAmount.mfs, name: action.payload },
        },
      };
    },
    saleMfsAmount: (state, action) => {
      state.paidAmount.mfs.amount = action.payload;
      totalCalculation(state);
    },
    salePointAmount: (state, action) => {
      state.paidAmount.point = action.payload;
      totalCalculation(state);
    },
    saleNewPoint: (state, action) => {
      return {
        ...state,
        point: {
          ...state.point,
          new: action.payload,
        },
      };
    },
    saleDiscount: (state, action) => {
      state.discount = action.payload;
      totalCalculation(state);
    },
    saleReturnProducts: (state, action) => {
      state.returnProducts = action.payload;
      totalCalculation(state);
    },
    saleReturnInfo: (state, action) => {
      return {
        ...state,
        returnInvoice: action.payload.returnInvoice,
        customerId: action.payload.customerId,
        customerPhone: action.payload.customerPhone,
        customerName: action.payload.customerName,
        point: {
          ...state.point,
          old: action.payload.customerPoint,
        },
      };
    },

    saleReturnQty: (state, action) => {
      let seletedItem = state.returnProducts.filter(
        (item) => item.article_code === action.payload.id
      );
      let restItem = state.returnProducts.filter(
        (item) => item.article_code !== action.payload.id
      );
      seletedItem = {
        ...seletedItem,
        qty: action.payload.qty,
      };
      restItem = { ...restItem, seletedItem };
      const returnItems = restItem.sort((a, b) => a.order - b.order);
      return {
        ...state,
        returnProducts: returnItems,
      };
    },
    saleReset: () => {
      const u = signInUser();
      const uId = u?.id || u?._id || u?.userId;
      return {
        ...intialState,
        billerId: uId || intialState.billerId,
        updateUser: uId || intialState.updateUser,
      };
    },
    setDue: (state, action) => {
      const isDue = action.payload;
      const cash =
        isDue === true
          ? state.paidAmount?.cash > 0
            ? state.paidAmount.cash
            : state.grossTotalRound
          : state.paidAmount?.cash || 0;

      const nextPaidAmount = {
        ...state.paidAmount,
        cash: cash,
      };

      const cashNum = parseInt(cash) || 0;
      const usePointAmount = parseInt(nextPaidAmount?.point) || 0;
      const mfs = parseInt(nextPaidAmount?.mfs?.amount) || 0;
      const card = parseInt(nextPaidAmount?.card?.amount) || 0;
      const promo_discount = parseInt(state?.promo_discount) || 0;
      const discount = parseInt(state?.discount) || 0;
      const grossTotal = parseInt(state?.grossTotal) || 0;

      const totalRecivedAmount = cashNum + card + mfs + usePointAmount;
      const changeAmount =
        totalRecivedAmount + promo_discount + discount - grossTotal;

      return {
        ...state,
        due: isDue,
        billType: isDue === true ? "due" : "paid",
        paidAmount: nextPaidAmount,
        totalReceived: totalRecivedAmount,
        changeAmount: changeAmount - discount,
      };
    },
  },
});

export const {
  selcetBiller,
  selcetCustomer,
  selcetProductsCart,
  saleFinalize,
  salesAmountRecived,
  saleCash,
  saleCardName,
  saleCardAmount,
  saleMfsName,
  saleMfsAmount,
  salePointAmount,
  saleDiscount,
  saleNewPoint,
  saleReset,
  selectInvoiceId,
  saleReturnProducts,
  saleReturnInfo,
  saleReturnQty,
  salesPromoPrice,
  setDue,
  selcetUpdateUser,
  selectGroup,
  selectAamarId,
  selectWarehouse,
  //New Reducers
  addToCartReducer,
  removeFromDbReducer,
  deleteShoppingCartReducer,
  removeQuantityReducer,
  addQuantityReducer,
  removeItemFormCartReducer,
  customQtyReducer,
  customPriceReducer,
  posCalculationReducer,
  posFinalizerReducer,
  removeItemFormReturnCartReducer,
  resetHoldReducer, //Reload the hold cart for sale
} = posSlice.actions;

export const posReducer = posSlice.reducer;
